import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { Subscription } from "rxjs";

@Component({
  selector: "app-extra-address-details-modal",
  templateUrl: "./extra-address-details-modal.component.html",
  styleUrls: ["./extra-address-details-modal.component.scss"],
})
export class ExtraAddressDetailsModalComponent implements OnInit, OnDestroy {
  @Input() isCustomer: boolean;
  @Input() scan_user: any;
  private unsubscribeBackEvent: Subscription;
  constructor(
    private modalController: ModalController,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      200,
      () => {
        if (this.platform.is("android")) {
          this.onClickCancel();
        }
      }
    );
  }

  onClickOk() {
    this.modalController.dismiss(
      this.scan_user,
      "",
      "extraAddressDetailsModal"
    );
  }

  onClickCancel() {
    this.modalController.dismiss(null, null, "extraAddressDetailsModal");
  }

  ngOnDestroy() {
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
  }
}
